import axios from 'axios';
import store from './store';
import router from './router';
import $mConfig from "@/common/index.config.js";

// axios 配置
axios.defaults.timeout = 5000;
// if(store.state.battalionCommander){
// 	$mConfig.baseUrl='https://api.jiarixiaodui.com/v1';
// };
axios.defaults.baseURL = $mConfig.baseUrl;
axios.interceptors.request.use(
  config => {
    // console.log(config.headers);
    if (store.state.token) {
      //console.log('config有token',store.state.token);
      config.headers.Authorization = `Bearer ${store.state.token}`;
    } else {
      // console.log('config没有token',store.state.token);
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

// http response 拦截器
// 
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          store.commit('SET_LOGOUT');
          if (router.currentRoute.fullPath.indexOf('/WxLogin') < 0) {
            window.localStorage.redirectUrl = router.currentRoute.fullPath;
            router.replace({
              path: '/WxLogin'
            });
          } else {
            router.replace({
              path: '/'
            });
          }
          break;


      }
    }
    console.log('error是', error);
    return Promise.reject(error.response.data)
  });

export default axios;